<script lang="ts" setup>
import { computed } from 'vue'

import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  BlockContainer
} from '@toni/brand-ui'

import { usePageStore } from '../../stores/page'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'
import { toValidHTML } from '../../utils/html-utils'
import { usePageBlockWidth } from '../../composables/use-page-block-width.ts'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'table')

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
</script>

<template>
  <BlockContainer :size="size"
                  class="mt-3 md:mt-4 mb-6 md:mb-8">
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead v-for="(headItem, headItemIndex) in contentBlock.data.table.head"
                     :key="`table-head-${headItemIndex}`">
            <span v-html="toValidHTML(headItem)" />
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow v-for="(rowItem, rowItemIndex) in contentBlock.data.table.body"
                  :key="`table-row-${rowItemIndex}`">
          <TableCell v-for="(rowItemCell, rowItemCellIndex) in rowItem"
                     :key="`table-row-${rowItemIndex}-cell-${rowItemCellIndex}`"
                     class="prose prose-a:text-secondary-500 focus-visible:prose-a:outline-0 focus-visible:prose-a:ring focus-visible:prose-a:ring-offset-1 focus-visible:prose-a:ring-ring hover:prose-a:text-primary-350 prose-a:decoration-from-font prose-a:underline-offset-2 [&_p]:m-0">
            <span v-html="toValidHTML(rowItemCell.content)" />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </BlockContainer>
</template>
